






import { Component, Vue, Prop } from 'vue-property-decorator';

import { FlexAlignment } from '../../app_code/FlexAlignment';

@Component
export default class SectionSubtitle extends Vue {
    @Prop()
    private readonly alignment!: FlexAlignment;
}
